/**
 * Obsługuje formularz danych do faktury dla Usług Płatnych Cyklicznie, w szczególności:
 * - otwieranie i zamykanie formularza
 * - przełączenie typu nabywcy (osoba prywatna / firma)
 * - zapewnia walidację pól formularza
 * - zapis danych
 */
app.service('subscriptionServiceInvoiceForm', function (loading, modal, account, validate, addressIntegrityValidator,
														subscriptionServiceBuyerInvoice, subscriptionServiceAdditionalEntityInvoice) {

	let forms = {};

	function init(props) {
		const {loadSubscriptionServiceDetails} = props;
		setEvents(loadSubscriptionServiceDetails);
	}

	function setEvents(loadSubscriptionServiceDetails) {

		$("body")
			.on("click", ".js-change-invoice-data", function () {

				const $form = $(this).closest('.invoice-details-section').find('.invoice-details-form');
				const recurringPaymentId = $form.find('input[name=recurringPaymentId]').val();

				let formInstance = forms[recurringPaymentId];

				if (formInstance && !formInstance.isConnected()) {
					delete forms[recurringPaymentId];
					formInstance = null;
				}

				if (!formInstance) {
					formInstance = createFormInstance($form, loadSubscriptionServiceDetails, recurringPaymentId);
					forms[recurringPaymentId] = formInstance;
				}

				formInstance.openForm();
			});
	}

	function createFormInstance($form, loadSubscriptionServiceDetails, recurringPaymentId) {

		let $self, $showAdditionalInvoiceCheckbox, $toggleTaxPayerRoleJst, $toggleTaxPayerRoleGrv, $invoiceTypeRadio;
		let buyerInvoice, additionalEntityInvoice;
		let initialized = false;
		let state = {};

		setFormElements();

		initOnce();

		function initOnce() {
			if (initialized) return;

			buyerInvoice = subscriptionServiceBuyerInvoice.init({
				$form,
				onChange: handleInvoiceChange
			});
			additionalEntityInvoice = subscriptionServiceAdditionalEntityInvoice.init({
				$form,
				onChange: handleAdditionalEntityInvoiceChange
			});

			setFormEvents();
			validateForm();

			initialized = true;
		}

		function openForm() {
			setState({
				isEditing: true,
				isCompanyUserType: $form.hasClass('is-company-user-type'),
				invoiceTaxIdType: $form.find('input[name="invoiceData.taxIdType"]').val() || 'NIP',
				showAdditionalInvoice: $showAdditionalInvoiceCheckbox.is(':checked'),
				additionalEntityRole: $form.find('input[name="additionalInvoiceEntity.role"]').val() || 'RECIPIENT',
				additionalEntityTaxId: $form.find('input[name="additionalInvoiceEntity.taxIdType"]').val() || 'NIP',
				taxPayerRoleJst: $toggleTaxPayerRoleJst.is(':checked'),
				taxPayerRoleGrv: $toggleTaxPayerRoleGrv.is(':checked')
			});
		}

		function setFormElements() {
			$self = $form.closest('.invoice-details-section');
			$showAdditionalInvoiceCheckbox = $form.find('input[name=showAdditionalInvoice]');
			$toggleTaxPayerRoleJst = $form.find('.js-toggle-tax-payer-role-jst');
			$toggleTaxPayerRoleGrv = $form.find('.js-toggle-tax-payer-role-grv');
			$invoiceTypeRadio = $form.find('input[name=invoiceType]');
		}

		function setState(newState) {
			state = Object.assign({}, state, newState);
			state = enforceAdditionalEntityTaxIdInvariant(state);
			renderForm();
		}

		function setFormEvents() {
			$form
				.on("change", ".invoice-type-switch input", handleInvoiceTypeSwitchClick)
				.on("click", ".js-cancel-data-change", handleCancelDataChangeClick)
				.on("change", "input[name=showAdditionalInvoice]", handleShowAdditionalInvoiceChange);

			$toggleTaxPayerRoleJst.on('change', handleToggleTaxPayerRoleJstChange);
			$toggleTaxPayerRoleGrv.on('change', handleToggleTaxPayerRoleGrvChange);
		}

		function validateForm() {
			validate.task('subscriptionServiceInvoiceDataForm', {
				$form: $form,
				onValidInvoiceData() {
					const invoiceFormData = getInvoiceFormData();
					handleValidInvoiceDataSubmit(recurringPaymentId, invoiceFormData, loadSubscriptionServiceDetails);
				}
			});
		}

		function handleInvoiceTypeSwitchClick() {
			const isCompanyUserType = !state.isCompanyUserType;
			const newState = {
				isCompanyUserType: isCompanyUserType,
				showAdditionalInvoice: isCompanyUserType && state.showAdditionalInvoice
			};

			if (!isCompanyUserType) {
				newState.taxPayerRoleJst = false;
				newState.taxPayerRoleGrv = false;
			}
			setState(newState);
		}

		function handleCancelDataChangeClick() {
			setState({isEditing: false});
			$.scrollTo($(this).closest(".subscription-item"));
		}

		function handleShowAdditionalInvoiceChange() {
			setState({showAdditionalInvoice: $(this).is(':checked')});
		}

		function handleToggleTaxPayerRoleJstChange() {
			const checked = $(this).is(':checked');

			setState({
				taxPayerRoleJst: checked,
				showAdditionalInvoice: !!checked,
				additionalEntityTaxId: 'NIP',
				additionalEntityRole: checked ? 'JST_RECIPIENT' : 'RECIPIENT'
			});
		}

		function handleToggleTaxPayerRoleGrvChange() {
			const checked = $(this).is(':checked');

			setState({
				taxPayerRoleGrv: checked,
				showAdditionalInvoice: !!checked,
				additionalEntityTaxId: 'NIP',
				additionalEntityRole: checked ? 'VAT_GROUP_MEMBER_RECIPIENT' : 'RECIPIENT'
			});
		}

		function handleInvoiceChange(newState) {
			setState(newState);
		}

		function handleAdditionalEntityInvoiceChange(newState) {
			setState(newState);
		}

		// Reguły poprawności identyfikatorów podatkowych dla Dodatkowego Podmiotu:
		// - Identyfikatory niefiskalne: NIP, INTERNAL_ID
		// - Identyfikatory fiskalne: NUMBER_ID, EMPTY_ID
		// - Krzyżowanie fiskalnych z niefiskalnymi zabronione tylko dla roli 'ADDITIONAL_BUYER' (Dodatkowy Nabywca)
		// - W innych rolach Dodatkowego Podmiotu krzyżowanie dozwolone
		function enforceAdditionalEntityTaxIdInvariant(state) {

			if (state.additionalEntityRole === 'ADDITIONAL_BUYER') {

				const invoiceFiscal = (state.invoiceTaxIdType === 'NUMBER_ID' || state.invoiceTaxIdType === 'EMPTY_ID');
				const additionalFiscal = (state.additionalEntityTaxId === 'NUMBER_ID' || state.additionalEntityTaxId === 'EMPTY_ID');

				if (!invoiceFiscal && additionalFiscal) {
					emptyAdditionalEntityDataOnMismatch();
					return Object.assign({}, state, {additionalEntityTaxId: 'NIP'});
				}

				if (invoiceFiscal && !additionalFiscal) {
					emptyAdditionalEntityDataOnMismatch();
					return Object.assign({}, state, {additionalEntityTaxId: 'NUMBER_ID'});
				}
			}

			return state;
		}

		function renderForm() {

			$self.toggleClass('is-expanded', state.isEditing);

			$form.toggleClass('is-company-user-type', state.isCompanyUserType);
			$form.toggleClass('is-individual-user-type', !state.isCompanyUserType);
			$form.toggleClass('hide-additional-invoice-checkbox', !state.isCompanyUserType || (state.additionalEntityRole === 'JST_RECIPIENT' || state.additionalEntityRole === 'VAT_GROUP_MEMBER_RECIPIENT'));

			$showAdditionalInvoiceCheckbox.prop('checked', state.showAdditionalInvoice);

			$toggleTaxPayerRoleJst.prop('checked', state.taxPayerRoleJst)
				.prop('disabled', state.taxPayerRoleGrv)
				.closest('.tax-payer-role')
				.toggleClass('is-disabled', state.taxPayerRoleGrv);

			$toggleTaxPayerRoleGrv.prop('checked', state.taxPayerRoleGrv)
				.prop('disabled', state.taxPayerRoleJst)
				.closest('.tax-payer-role')
				.toggleClass('is-disabled', state.taxPayerRoleJst);

			$invoiceTypeRadio.filter(`[value="${state.isCompanyUserType ? 'COMPANY' : 'INDIVIDUAL'}"]`).prop('checked', true);

			buyerInvoice.render({
				invoiceTaxIdType: state.invoiceTaxIdType,
				isCompanyUserType: state.isCompanyUserType
			});
			additionalEntityInvoice.render({
				isCompanyUserType: state.isCompanyUserType,
				showAdditionalInvoice: state.showAdditionalInvoice,
				additionalEntityRole: state.additionalEntityRole,
				additionalEntityTaxId: state.additionalEntityTaxId,
				invoiceTaxIdType: state.invoiceTaxIdType,
				taxPayerRoleJst: state.taxPayerRoleJst,
				taxPayerRoleGrv: state.taxPayerRoleGrv
			});
		}

		function getInvoiceFormData() {

			let formData = {
				invoiceData: null,
				additionalInvoiceEntity: null,
				recurringPaymentId: null,
			};

			formData.recurringPaymentId = getFieldValue('recurringPaymentId');

			formData.invoiceData = {
				taxIdType: getFieldValue('invoiceData.taxIdType'),
				companyName: getFieldValue('invoiceData.companyName'),
				nip: getFieldValue('invoiceData.nip'),
				numberId: getFieldValue('invoiceData.numberId'),
				firstName: getFieldValue('invoiceData.firstName'),
				lastName: getFieldValue('invoiceData.lastName'),
				address: {
					zipCode: getFieldValue('invoiceData.address.zipCode'),
					street: getFieldValue('invoiceData.address.street'),
					city: getFieldValue('invoiceData.address.city'),
					houseNumber: getFieldValue('invoiceData.address.houseNumber'),
					flatNumber: getFieldValue('invoiceData.address.flatNumber'),
					countryCode: getFieldValue('invoiceData.address.countryCode')
				}
			};

			if (state.showAdditionalInvoice) {
				formData.additionalInvoiceEntity = {
					role: getFieldValue('additionalInvoiceEntity.role'),
					taxIdType: getFieldValue('additionalInvoiceEntity.taxIdType'),
					roleDescription: getFieldValue('additionalInvoiceEntity.roleDescription'),
					percentageShare: getFieldValue('additionalInvoiceEntity.percentageShare'),
					email: getFieldValue('additionalInvoiceEntity.email'),
					nip: getFieldValue('additionalInvoiceEntity.nip'),
					numberId: getFieldValue('additionalInvoiceEntity.numberId'),
					internaId: getFieldValue('additionalInvoiceEntity.internalId'),
					companyName: getFieldValue('additionalInvoiceEntity.companyName'),
					employeeName: getFieldValue('additionalInvoiceEntity.employeeName'),
				};

				formData.additionalInvoiceEntity.address = getAdditionalInvoiceEntityAddress();
			}

			return formData;
		}

		function getAdditionalInvoiceEntityAddress() {
			const zipCode = getFieldValue('additionalInvoiceEntity.address.zipCode');
			const street = getFieldValue('additionalInvoiceEntity.address.street');
			const city = getFieldValue('additionalInvoiceEntity.address.city');
			const houseNumber = getFieldValue('additionalInvoiceEntity.address.houseNumber');
			const flatNumber = getFieldValue('additionalInvoiceEntity.address.flatNumber');
			const countryCode = getFieldValue('additionalInvoiceEntity.address.countryCode');

			if (!zipCode || !street || !city || !houseNumber || !countryCode) {
				return null;
			}

			return {
				zipCode,
				street,
				city,
				houseNumber,
				flatNumber,
				countryCode
			};
		}

		function getFieldValue(selector) {
			const $el = $form.find(`[name="${selector}"]`);
			return $el.is(':disabled') ? null : $el.val();
		}

		function isConnected() {
			return document.contains($form[0]);
		}

		function emptyAdditionalEntityDataOnMismatch() {
			const names = [
				'additionalInvoiceEntity.address.zipCode',
				'additionalInvoiceEntity.address.street',
				'additionalInvoiceEntity.address.city',
				'additionalInvoiceEntity.address.houseNumber',
				'additionalInvoiceEntity.address.flatNumber'
			];
			names.forEach(n => $form.find(`[name="${n}"]`).val(''));
			$form.find('[name="additionalInvoiceEntity.email"]').val('');
			$form.find('[name="additionalInvoiceEntity.companyName"]').val('');
			$form.find('[name="additionalInvoiceEntity.percentageShare"]').val('');
		}

		return {
			openForm,
			isConnected
		};
	}

	function handleValidInvoiceDataSubmit(recurringPaymentId, invoiceFormData, loadSubscriptionServiceDetails) {

		let requestData = {
			isInvoice: true,
			containsTelecommunicationRelatedItems: true,
			invoiceCityName: invoiceFormData.invoiceData.address.city,
			invoiceZipCode: invoiceFormData.invoiceData.address.zipCode,
			invoiceAddressStreet: invoiceFormData.invoiceData.address.street,
		};

		if (invoiceFormData.additionalInvoiceEntity && invoiceFormData.additionalInvoiceEntity.address) {

			$.extend(requestData, {
				isAdditionalEntityInvoice: true,
				containsTelecommunicationRelatedItems: true,
				additionalEntityInvoiceCityName: invoiceFormData.additionalInvoiceEntity.address.city,
				additionalEntityInvoiceZipCode: invoiceFormData.additionalInvoiceEntity.address.zipCode,
				additionalEntityInvoiceStreet: invoiceFormData.additionalInvoiceEntity.address.street,
			});
		}

		addressIntegrityValidator.validate({
			data: requestData,
			onSuccess: () => makeUpdateInvoiceDataRequest(recurringPaymentId, invoiceFormData, loadSubscriptionServiceDetails)
		});
	}

	function makeUpdateInvoiceDataRequest(recurringPaymentId, invoiceFormData, loadSubscriptionServiceDetails) {

		loading.start();

		$.ajax({
			url: "/customer-subscription-invoice-data-update.ltr",
			type: "POST",
			dataType: "json",
			contentType: "application/json",
			data: JSON.stringify(invoiceFormData)
		})
			.then(response => {
				if (response.status === "FAIL") {
					modal.alert(response.messages.join("<br />"));
					return;
				}

				return loadSubscriptionServiceDetails(recurringPaymentId)
					.then(html => {
						let $subscriptionItem = $(`.subscription-item[data-id=${recurringPaymentId}]`);
						$subscriptionItem.find('.subscription-item-details').html(html);
						delete forms[recurringPaymentId];
						modal.close();
						$.scrollTo($subscriptionItem);
					});
			})
			.fail(() => {
				modal.alert(getErrorMsg());
			})
			.always(() => {
				loading.stop();
			});
	}

	function getErrorMsg() {
		return '<div class="error-message">Wystąpił błąd komunikacji. Odśwież stronę, aby próbować ponownie.</div>';
	}

	return {
		init
	};
});